import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const RevertirEntrada = () => {
  const api = useApi();
  const mutate = async (params) => {
    const data = await api.get(`/administracion-inventario/revert/entrada/${params}`);
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    revertirEntradaMutation: mutation.mutate,
  };
}